import classNames from "classnames";
import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Form, FormMessage, Accordion, Button } from "lib/components/index";

import ProductCustomerOrderFieldFormSection from "lib/components/FormSection/ProductCustomerOrderFieldFormSection";
import { st, FormControl, HintView } from "lib/index";
import { ProductOrderFieldDecorator } from "lib/decorators/index";
import { stateSelector, updateProduct, validate, save } from "../index";
import Hint from "./StepCustomerFieldsHint";

@connect(
  (state) => ({
    product: stateSelector(state).product,
    submitLoading: stateSelector(state).submitLoading,
    valid: stateSelector(state).valid,
    errors: stateSelector(state).errors,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        updateProduct,
        validate,
        save,
      },
      dispatch
    )
)
export default class StepCustomerFieldsForm extends React.PureComponent {
  state = {
    newFields: {
      assignation_per_order: null,
      assignation_per_person: null,
    },
  };

  componentDidMount() {
    this._createNewField({ assignation_type: "assignation_per_order" }, () => {
      this._createNewField({ assignation_type: "assignation_per_person" });
    });
  }

  _createNewField({ assignation_type }, callback) {
    const { product } = this.props;
    const newField = ProductOrderFieldDecorator.build({
      _new: true,
      preset_id_or_type: null,
      assignation_type,
      price_type: "price_none",
      position: Math.max(0, ...product.product_order_fields.map((field) => field.position)) + 1,
    });
    this.setState(
      {
        newFields: {
          ...this.state.newFields,
          [assignation_type]: newField,
        },
      },
      callback
    );
  }

  handleSubmit(event) {
    const { save } = this.props;
    event.preventDefault();
    save();
  }

  handleAddProductOrderField(newField) {
    const { product, updateProduct } = this.props;
    if (newField.preset_id) {
      const field = product.product_order_fields.find((f) => f.preset_id === newField.preset_id);
      const nextField = new ProductOrderFieldDecorator({
        ...field,
        active: true,
      });
      this.handleUpdateProductOrderField(nextField);
    } else {
      const product_order_fields = product.product_order_fields.concat([{ ...newField, hint_editable: true }]);

      updateProduct({
        ...product,
        product_order_fields,
      });
    }
  }

  handleUpdateProductOrderField(nextField) {
    const { product, updateProduct } = this.props;
    if (nextField._new) {
      this._createNewField({ assignation_type: nextField.assignation_type });
      this.handleAddProductOrderField(new ProductOrderFieldDecorator({ ...nextField, _new: undefined, _focus: true }));
    } else {
      const product_order_fields = product.product_order_fields.map((f) => (f.uuid === nextField.uuid ? nextField : f));
      updateProduct({
        ...product,
        product_order_fields,
      });
    }
  }

  handleRemoveProductOrderField(field) {
    const { product, updateProduct, validate } = this.props;
    const product_order_fields = product.product_order_fields.filter((f) => f.uuid !== field.uuid);
    updateProduct({
      ...product,
      product_order_fields,
    });
    validate();
  }

  render() {
    const { readOnlyAccess, product, editedLocale, submitLoading, valid, errors, validate } = this.props;
    const { newFields } = this.state;

    return (
      <HintView.Container>
        <HintView.Content>
          <Form className="text" onSubmit={this.handleSubmit.bind(this)} error={!valid} loading={submitLoading}>
            {!!errors.base && <FormMessage error={errors.base} />}

            <h2>{I18n.t("papp.products.EditProductView.StepCustomerFields.customer_fields")}</h2>

            {product.customer_fields
              .filter((field) => field.assignation_type === "assignation_per_order")
              .filter((field) => field.active)
              .concat(!readOnlyAccess && newFields.assignation_per_order ? [newFields.assignation_per_order] : [])
              .map((field) => (
                <ProductCustomerOrderFieldFormSection
                  key={field.uuid}
                  name={`product.product_order_fields[${field.uuid}]`}
                  errors={errors}
                  product_order_field={field}
                  editedLocale={editedLocale}
                  onBlur={validate}
                  onChange={this.handleUpdateProductOrderField.bind(this)}
                  onRemove={this.handleRemoveProductOrderField.bind(this, field)}
                  excludedPresetIds={product.customer_fields
                    .filter((f) => f.active && f.preset_id)
                    .map((f) => f.preset_id)}
                  readOnly={readOnlyAccess}
                />
              ))}

            {product.product_type !== "coupon" && (
              <div className="u-marginTop">
                <h2>{I18n.t("papp.products.EditProductView.StepCustomerFields.participant_fields")}</h2>

                {product.customer_fields
                  .filter((field) => field.assignation_type === "assignation_per_person")
                  .filter((field) => field.active)
                  .concat(!readOnlyAccess && newFields.assignation_per_person ? [newFields.assignation_per_person] : [])
                  .map((field) => (
                    <ProductCustomerOrderFieldFormSection
                      key={field.uuid}
                      name={`product.product_order_fields[${field.uuid}]`}
                      errors={errors}
                      product_order_field={field}
                      editedLocale={editedLocale}
                      onBlur={validate}
                      onChange={this.handleUpdateProductOrderField.bind(this)}
                      onRemove={this.handleRemoveProductOrderField.bind(this, field)}
                      excludedPresetIds={product.customer_fields
                        .filter((f) => f.active && f.preset_id)
                        .map((f) => f.preset_id)}
                      readOnly={readOnlyAccess}
                    />
                  ))}
              </div>
            )}

            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />

            <button type="submit" disabled={submitLoading} hidden />
          </Form>
        </HintView.Content>
        <HintView.Sidebar>
          <Hint />
        </HintView.Sidebar>
      </HintView.Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepCustomerFields/StepCustomerFieldsForm.jsx